<script lang="ts">
import type { AssetSpecValue } from '~/components/Sdp/SdpSpecsSection.vue';

interface SdpSpecItemProps {
    name: TypedTranslateReturn;
    value: AssetSpecValue;
}
</script>

<script setup lang="ts">
// PROPS
defineProps<SdpSpecItemProps>();

// DATA
</script>

<template>
    <p v-if="typeof value === 'boolean'" class="flex items-center">
        <UIcon v-if="value" name="lucide:circle-check" class="text-primary-500" />
        <UIcon v-else name="lucide:circle-x" class="text-dimmed" />
        <span class="ml-2" :class="{ 'line-through': !value }">{{ name }}</span>
    </p>
    <p v-else-if="value !== null">
        {{ name }}:&nbsp; <span class="text-primary">{{ value }}</span>
    </p>
</template>
